export default "/images/08df27d038259fce83eb83602ea03f78.avif";